import React from 'react';
import {
  TextField,
  Box,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface FreelancerResponseInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  actionType: 'revise' | 'submit';
}

const FreelancerResponseInput: React.FC<FreelancerResponseInputProps> = ({
  value,
  onChange,
  error,
  actionType
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        {t(`proposal.freelancerResponse.${actionType}Description`)}
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={4}
        label={t('proposal.freelancerResponse.messageLabel')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        helperText={error}
        placeholder={t(`proposal.freelancerResponse.${actionType}Placeholder`)}
      />
    </Box>
  );
};

export default FreelancerResponseInput;
